// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"838":"58a98e561c5c2a22","883":"598ec7c49ac552ba","3381":"71abaa79c075fd66","4106":"6d10c70c6882c28d"}[chunkId] + ".css";
};